// FrontEnd shapes
const mealTimes = ["desayuno", "almuerzo", "comida", "merienda", "cena", "resopon"] as const
type MealTime = typeof mealTimes[number]

const dishTypes = ['starter', 'main', 'unique', 'extra', 'dessert'] as const
type DishType = typeof dishTypes[number]

const dishDifficulties = ["low", "medium", "high"] as const
export type DishDifficulty = typeof dishDifficulties[number]


const mealTimesCorrespondence: Record<string, MealTime> = {
    BREA: "desayuno",
    MIDS: "almuerzo",
    LUNC: "comida",
    AFTS: "merienda",
    DINN: "cena",
    AFDS: "resopon"
} as const


export function convertMealTimes(mealTime: string): MealTime {

    const convertedMealTime = mealTimesCorrespondence[mealTime]
    if (!convertMealTimes)
        throw new Error(`Passed unknown mealTime ${mealTime} to convertMealTimes function`)
    return convertedMealTime
}





const difficultiesCorrespondence: Record<string, DishDifficulty> = {
    LOW: "low",
    MEDI: "medium",
    HIGH: "high"

}




export function convertDishDifficuly(difficulty: string): DishDifficulty {
    const convertedDifficulty = difficultiesCorrespondence[difficulty];
    if (!convertedDifficulty)
        throw new Error(`Passed unknown difficulty ${difficulty} to export function convertDishDifficuly`)
    return convertedDifficulty

}








const dishTypeCorrespondence: Record<string, DishType> = {
    STAR: "starter",
    DESS: "dessert",
    EXTR: "extra",
    MAIN: "main",
    UNIQ: "unique"
} as const


export function convertDishTypes(dishType: string): DishType {
    const convertedDishType = dishTypeCorrespondence[dishType];
    if (!dishType)
        throw new Error(`Passed unknown dishType : '${dishType} to convertDishTypes`)
    return convertedDishType
}





const backendWeekDays = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"] as const
export type BackendWeekDaysType = typeof backendWeekDays[number]
//HERE
const weekDayCorrespondence: Record<BackendWeekDaysType, any> = {
    MON: {
        label: "monday",
        weekIndex: 0
    },
    TUE: {
        label: "tuesday",
        weekIndex: 1
    },
    WED: {
        label: "wednesday",
        weekIndex: 2
    },
    THU: {
        label: "thursday",
        weekIndex: 3
    },
    FRI: {
        label: "friday",
        weekIndex: 4
    },
    SAT: {
        label: "saturday",
        weekIndex: 5
    },
    SUN: {
        label: "sunday",
        weekIndex: 6

    }

} as const



export function convertWeekdayToIndex(weekdayBackendKey: BackendWeekDaysType): number {
    const convertedWeekDay = weekDayCorrespondence[weekdayBackendKey]?.weekIndex;
    if (!convertWeekdayToIndex)
        throw new Error(`Passed unknown dishType : '${weekdayBackendKey} to convertWeekdayToIndex`)
    return convertedWeekDay
}
